(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[747],{

/***/ 43965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ CompanyRight; },
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(32641);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-themes@0.2.1_azq6kxkn3od7qdylwkyksrwopy/node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(30060);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../packages/ui/src/components/link/link.tsx
var link_link = __webpack_require__(7278);
// EXTERNAL MODULE: ../../packages/ui/src/components/client-only/client-only.tsx
var client_only = __webpack_require__(32631);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.3_biqbaboplfbrettd7655fr4n2y/node_modules/@headlessui/react/dist/components/listbox/listbox.js + 1 modules
var listbox = __webpack_require__(47363);
// EXTERNAL MODULE: ../../node_modules/.pnpm/framer-motion@7.6.2_biqbaboplfbrettd7655fr4n2y/node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(43953);
// EXTERNAL MODULE: ../../node_modules/.pnpm/framer-motion@7.6.2_biqbaboplfbrettd7655fr4n2y/node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(85385);
// EXTERNAL MODULE: ../../packages/ui/src/styles/common.ts
var common = __webpack_require__(55161);
// EXTERNAL MODULE: ../../packages/ui/src/components/animation/ease-in-out.ts
var ease_in_out = __webpack_require__(73420);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/chevronDownCircleFill.js
var chevronDownCircleFill = __webpack_require__(54157);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/check.js
var check = __webpack_require__(34499);
// EXTERNAL MODULE: ../../packages/ui/src/components/select/select.module.scss
var select_module = __webpack_require__(55076);
var select_module_default = /*#__PURE__*/__webpack_require__.n(select_module);
;// CONCATENATED MODULE: ../../packages/ui/src/components/select/select.tsx











const VARIANT_CLASSES = {
    borderless: "border border-transparent",
    default: "border"
};
const PLACEMENT_CLASSES = {
    top: "bottom-0",
    bottom: ""
};
function Select(props) {
    var ref;
    const { name , value , children , onChange , label , className , variant ="default" , placement ="bottom" ,  } = props;
    const childrenArray = react.Children.toArray(children);
    // Find the selected option's children element
    const selectedOptionChildren = (ref = childrenArray.find((elm)=>elm.props.value === value)) === null || ref === void 0 ? void 0 : ref.props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox */.R, {
        value: value,
        onChange: onChange,
        children: (param)=>/*#__PURE__*/ {
            let { open  } = param;
            return (0,jsx_runtime.jsxs)("div", {
                className: "text-gray-1100",
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Label */.R.Label, {
                        className: "mb-1 block text-sm font-bold",
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("relative", className),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(listbox/* Listbox.Button */.R.Button, {
                                    className: (0,clsx_m/* default */.Z)("relative w-full cursor-default rounded py-2 pl-3 pr-8 text-left transition duration-150 ease-in-out hover:border-primary-700 focus-visible:outline-none focus-visible:ring-primary-700", VARIANT_CLASSES[variant]),
                                    "aria-label": props["aria-label"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: childrenWrapper,
                                            children: selectedOptionChildren || name || value
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (0,clsx_m/* default */.Z)("pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 text-gray-300", (select_module_default()).icon),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chevronDownCircleFill/* default */.Z, {
                                                size: 18
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                children: open && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ease_in_out/* easeInOut */.m), {
                                    className: (0,clsx_m/* default */.Z)("absolute z-20 mt-1 w-full rounded-md shadow-lg", common/* bluredBg */.a4, PLACEMENT_CLASSES[placement]),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Options */.R.Options, {
                                        static: true,
                                        className: "max-h-60 overflow-auto overscroll-contain rounded border border-gray-400 py-1 px-0.5 text-base focus-visible:outline-none sm:text-sm",
                                        children: children
                                    })
                                }))
                            })
                        ]
                    })
                ]
            });
        }
    });
}
Select.Option = SelectOption;
function SelectOption(param) {
    let { value , children , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(listbox/* Listbox.Option */.R.Option, {
        value: value,
        children: (param)=>/*#__PURE__*/ {
            let { selected , active  } = param;
            return (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)(active && common/* listHoverable */.D6, "relative cursor-pointer select-none py-2 pl-7 pr-4 text-gray-1100"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,clsx_m/* default */.Z)(childrenWrapper, className),
                        children: children
                    }),
                    selected && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (0,clsx_m/* default */.Z)(active && common/* listHoverable */.D6, "absolute inset-y-0 left-0 flex items-center pl-1.5"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(check/* default */.Z, {
                            size: 16
                        })
                    })
                ]
            });
        }
    }, String(value));
}
const childrenWrapper = "flex flex-row items-center space-x-1";

// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/sun.js
var sun = __webpack_require__(43574);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/moon.js
var moon = __webpack_require__(36914);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/settings.js
var settings = __webpack_require__(16440);
// EXTERNAL MODULE: ../../packages/ui/src/components/text/text.tsx
var text_text = __webpack_require__(47098);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/footer/footer.tsx








function Footer(_param) {
    var { className  } = _param, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    const { theme , setTheme  } = (0,index_module/* useTheme */.F)();
    const handleChange = (value)=>{
        setTheme(value);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        className: (0,clsx_m/* default */.Z)("my-10 flex w-full flex-col items-start justify-between space-y-5 border-t border-gray-500 py-10 transition duration-150", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: "flex w-full flex-row flex-wrap justify-center space-x-6 leading-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                        href: "/docs",
                        variant: "secondary",
                        children: "Docs"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                        href: "/blog",
                        variant: "secondary",
                        children: "Blog"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                        href: "/#pricing",
                        variant: "secondary",
                        children: "Pricing"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                        href: "/terms-of-service",
                        variant: "secondary",
                        children: "Terms"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                        href: "/privacy-policy",
                        variant: "secondary",
                        children: "Privacy"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-col items-center justify-center space-y-4 sm:flex-row sm:space-y-0 sm:space-x-5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyRight, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(client_only/* ClientOnly */.q, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select, {
                            value: theme || "system",
                            onChange: handleChange,
                            className: "w-32",
                            placement: "top",
                            "aria-label": "Mode selector",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select.Option, {
                                    value: "light",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(sun/* default */.Z, {
                                            size: 16
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Light"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select.Option, {
                                    value: "dark",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(moon/* default */.Z, {
                                            size: 16
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Dark"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select.Option, {
                                    value: "system",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(settings/* default */.Z, {
                                            size: 16
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "System"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }));
}
function CompanyRight() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_text/* Text */.x, {
        variant: "secondary",
        size: "sm",
        className: "px-2 sm:px-0",
        children: [
            "\xa9 ",
            new Date().getFullYear(),
            " Chirpy Information Technology LLC. All rights reserved."
        ]
    });
}


/***/ }),

/***/ 65747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SiteLayout; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.1_biqbaboplfbrettd7655fr4n2y/node_modules/next/head.js
var head = __webpack_require__(28426);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../packages/ui/src/contexts/theme-context/use-theme-variables.ts
var use_theme_variables = __webpack_require__(85601);
;// CONCATENATED MODULE: ../../packages/ui/src/contexts/theme-context/site-theme-provider.tsx




function SiteThemeProvider(props) {
    const { styles  } = (0,use_theme_variables/* useThemeVariables */.X)();
    react.useEffect(()=>{
        // Add site specific global styles
        document.body.classList.add("site");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("style", {
                    children: styles
                }, "site-theme")
            }),
            props.children
        ]
    });
}

// EXTERNAL MODULE: ../../packages/ui/src/blocks/footer/footer.tsx + 1 modules
var footer = __webpack_require__(43965);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/sign-in-button/sign-in-button.tsx
var sign_in_button = __webpack_require__(76704);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/user-menu/user-menu.tsx
var user_menu = __webpack_require__(98069);
// EXTERNAL MODULE: ../../packages/ui/src/components/link/link.tsx
var link_link = __webpack_require__(7278);
// EXTERNAL MODULE: ../../packages/ui/src/components/logo/logo.tsx
var logo = __webpack_require__(49306);
// EXTERNAL MODULE: ../../packages/ui/src/contexts/current-user-context/use-current-user.ts
var use_current_user = __webpack_require__(29560);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/notification-hub/notification-hub.tsx + 3 modules
var notification_hub = __webpack_require__(88877);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/side-menu/side-menu.tsx + 4 modules
var side_menu = __webpack_require__(61551);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/header/header.tsx










function Header() {
    const { isSignIn  } = (0,use_current_user/* useCurrentUser */.x)();
    const styles = "ml-[22px]";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: (0,clsx_m/* default */.Z)("relative z-20 w-full py-3 shadow-xs transition duration-150 sm:sticky sm:top-0 sm:left-0", // Can't use the normal backdrop-filter here as it'll cause nested blur elements not working in chrome.
        "before:z-index-[-1] before:absolute before:inset-0 before:bg-gray-0 before:bg-opacity-75 before:backdrop-blur-xl before:backdrop-saturate-150 before:dark:bg-opacity-70"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto max-w-7xl px-2 sm:px-6 lg:px-8",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "flex flex-row items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center pl-3 sm:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(side_menu/* SideMenu */.f, {
                            children: [
                                isSignIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(side_menu/* SideMenu.Item */.f.Item, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                        size: "lg",
                                        href: "/dashboard",
                                        className: styles,
                                        highlightPattern: /^\/dashboard/,
                                        children: "Dashboard"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(side_menu/* SideMenu.Item */.f.Item, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                        size: "lg",
                                        href: "/#pricing",
                                        className: styles,
                                        highlightPattern: /^\/#pricing/,
                                        children: "Pricing"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(side_menu/* SideMenu.Item */.f.Item, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                        size: "lg",
                                        href: "/docs",
                                        className: styles,
                                        highlightPattern: /^\/docs/,
                                        children: "Docs"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(side_menu/* SideMenu.Item */.f.Item, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                        size: "lg",
                                        href: "/blog",
                                        className: styles,
                                        highlightPattern: /^\/blog/,
                                        children: "Blog"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(side_menu/* SideMenu.Item */.f.Item, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                        size: "lg",
                                        href: "https://github.com/devrsi0n/chirpy",
                                        className: styles,
                                        children: "GitHub"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row sm:items-stretch sm:justify-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row items-center space-x-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* Logo */.T, {
                                    showBadge: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                className: "mb-5 hidden w-full flex-wrap items-center space-x-8 sm:mb-0 sm:ml-8 sm:flex sm:border-l sm:border-gray-500 sm:pl-8",
                                children: [
                                    isSignIn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                        href: "/dashboard",
                                        highlightPattern: /^\/dashboard/,
                                        children: "Dashboard"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                        href: "/#pricing",
                                        highlightPattern: /^\/#pricing/,
                                        children: "Pricing"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                        href: "/docs",
                                        highlightPattern: /^\/docs/,
                                        children: "Docs"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                        href: "/blog",
                                        highlightPattern: /^\/blog/,
                                        children: "Blog"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.r, {
                                        href: "https://github.com/devrsi0n/chirpy",
                                        children: "GitHub"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex",
                        children: isSignIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(notification_hub/* NotificationHub */.u, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(user_menu/* UserMenu */.I, {
                                    variant: "Nav"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(sign_in_button/* SignInButton */.$, {
                            inPageNav: true
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ../../packages/ui/src/blocks/layout/layout-wrapper.tsx
var layout_wrapper = __webpack_require__(74692);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/layout/layout.module.scss
var layout_module = __webpack_require__(3921);
var layout_module_default = /*#__PURE__*/__webpack_require__.n(layout_module);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/layout/site-layout.tsx








function SiteLayout(param) {
    let { title , hideHeader , hideFooter , enableBgGradient , children , styles , hideFullBleed  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteThemeProvider, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_wrapper/* LayoutWrapper */.W, {
            title: title,
            className: (0,clsx_m/* default */.Z)(enableBgGradient && "before:absolute before:inset-0 before:content-['']", enableBgGradient && (layout_module_default()).layoutWrapper),
            children: [
                !hideHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: (0,clsx_m/* default */.Z)("min-h-full py-16 md:mx-4", // https://www.joshwcomeau.com/css/full-bleed/
                    !hideFullBleed && (layout_module_default()).layoutMain, styles === null || styles === void 0 ? void 0 : styles.container),
                    children: children
                }),
                !hideFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer */.$, {
                    className: "mt-auto"
                })
            ]
        })
    });
}


/***/ }),

/***/ 88877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ NotificationHub; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(32641);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(15771);
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(39355);
// EXTERNAL MODULE: ../../node_modules/.pnpm/urql@3.0.3_onqnqwb3ubg5opvemcqf7c2qhy/node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(28825);
;// CONCATENATED MODULE: ../../packages/graphql/src/frontend/generated/notification.tsx


function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query currentNotificationMessages($userId: uuid!) {\n    notificationMessages(\n      where: { recipientId: { _eq: $userId } }\n      order_by: { createdAt: desc, read: asc }\n    ) {\n      id\n      recipient {\n        id\n        name\n        username\n        email\n        image\n      }\n      type\n      url\n      triggeredBy {\n        id\n        name\n        username\n        email\n        image\n      }\n      content\n      read\n      createdAt\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation haveReadANotification($messageId: uuid!) {\n    updateNotificationMessageByPk(\n      pk_columns: { id: $messageId }\n      _set: { read: true }\n    ) {\n      id\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation deleteNotificationMessage($messageId: uuid!) {\n    deleteNotificationMessageByPk(id: $messageId) {\n      id\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


const CurrentNotificationMessagesDocument = (0,lib/* default */.ZP)(_templateObject());
function useCurrentNotificationMessagesQuery(options) {
    return urql_es/* useQuery */.aM((0,_object_spread/* default */.Z)({
        query: CurrentNotificationMessagesDocument
    }, options));
}
const HaveReadANotificationDocument = (0,lib/* default */.ZP)(_templateObject1());
function useHaveReadANotificationMutation() {
    return urql_es/* useMutation */.Db(HaveReadANotificationDocument);
}
const DeleteNotificationMessageDocument = (0,lib/* default */.ZP)(_templateObject2());
function useDeleteNotificationMessageMutation() {
    return urql_es/* useMutation */.Db(DeleteNotificationMessageDocument);
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../packages/ui/src/components/badge/badge.tsx
var badge = __webpack_require__(98502);
// EXTERNAL MODULE: ../../packages/ui/src/components/heading/heading.tsx
var heading = __webpack_require__(36609);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/bell.js
var bell = __webpack_require__(45030);
// EXTERNAL MODULE: ../../packages/ui/src/components/menu/menu.tsx
var menu = __webpack_require__(2786);
// EXTERNAL MODULE: ../../packages/ui/src/components/spinner/spinner.tsx
var spinner = __webpack_require__(32075);
// EXTERNAL MODULE: ../../packages/ui/src/components/text/text.tsx
var text_text = __webpack_require__(47098);
// EXTERNAL MODULE: ../../packages/ui/src/contexts/current-user-context/use-current-user.ts
var use_current_user = __webpack_require__(29560);
// EXTERNAL MODULE: ../../packages/ui/src/hooks/use-bypass-cache-refetch.ts
var use_bypass_cache_refetch = __webpack_require__(88905);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/notification-hub/notification-hub.module.scss
var notification_hub_module = __webpack_require__(74394);
var notification_hub_module_default = /*#__PURE__*/__webpack_require__.n(notification_hub_module);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../packages/ui/src/components/avatar/avatar.tsx + 1 modules
var avatar = __webpack_require__(54230);
// EXTERNAL MODULE: ../../packages/ui/src/components/divider/divider.tsx
var divider = __webpack_require__(91828);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/x.js
var x = __webpack_require__(12953);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/messageSquare.js
var messageSquare = __webpack_require__(92163);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/heartFill.js
var heartFill = __webpack_require__(19398);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/xSquare.js
var xSquare = __webpack_require__(29323);
// EXTERNAL MODULE: ../../packages/ui/src/components/link/link.tsx
var link_link = __webpack_require__(7278);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.1_biqbaboplfbrettd7655fr4n2y/node_modules/next/router.js
var next_router = __webpack_require__(34883);
;// CONCATENATED MODULE: ../../packages/ui/src/hooks/use-is-widget.ts

function useIsWidget() {
    const router = (0,next_router.useRouter)();
    return router.pathname.startsWith("/widget");
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/dayjs@1.11.5/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(35708);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ../../packages/ui/src/blocks/notification-hub/notification-item.tsx














function NotificationItem(param) {
    let { index , message , length , onClickCapture , onClickDelete  } = param;
    const deleteButtonRef = react.useRef(null);
    const isWidget = useIsWidget();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu.Item */.v.Item, {
        className: (0,clsx_m/* default */.Z)("mt-0 flex-col items-start rounded-none px-5 pt-3 pb-0 !text-left hover:rounded", !message.read && "bg-gray-600/30"),
        onClickCapture: (e)=>{
            var ref;
            if ((ref = deleteButtonRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target)) {
                e.preventDefault();
                return;
            }
            onClickCapture(message.id);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(link_link/* Link */.r, {
                href: message.url,
                variant: "plain",
                className: "group mb-2 flex w-full flex-row items-start space-x-2",
                target: isWidget ? "_blank" : "_self",
                children: [
                    ICON_MAP[message.type],
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                                        src: message.triggeredBy.image,
                                        alt: "".concat(message.triggeredBy.name, "'s avatar"),
                                        email: message.triggeredBy.email,
                                        name: message.triggeredBy.name,
                                        username: message.triggeredBy.username,
                                        className: "mb-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: "hidden h-fit translate-x-3 -translate-y-1 rounded-full p-0.5 hover:bg-primary-600 group-hover:inline",
                                        onClick: (e)=>{
                                            onClickDelete(message.id);
                                            e.stopPropagation();
                                        },
                                        ref: deleteButtonRef,
                                        "aria-label": "Delete the notification message",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(x/* default */.Z, {
                                            size: 18
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationText, {
                                className: "flex flex-row space-x-1.5 leading-none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "max-w-[8rem] truncate font-bold",
                                        children: message.triggeredBy.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: TITLE_MAP[message.type]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationText, {
                                variant: "secondary",
                                as: "time",
                                size: "sm",
                                className: "mt-1 block cursor-default leading-none",
                                dateTime: message.createdAt,
                                children: dayjs_min_default()(message.createdAt).fromNow()
                            }),
                            message.content && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationText, {
                                size: "sm",
                                className: "mt-2 max-w-[15rem] truncate",
                                variant: "secondary",
                                title: message.content,
                                "aria-label": "Comment content",
                                children: message.content
                            })
                        ]
                    })
                ]
            }),
            index < length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* Divider */.i, {
                className: "w-full group-hover:bg-primary-400"
            })
        ]
    }, message.id);
}
function NotificationText(_param) {
    var { className  } = _param, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text/* Text */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        className: (0,clsx_m/* default */.Z)("group-hover:text-primary-1100", className)
    }));
}
const TITLE_MAP = {
    ReceivedAComment: "left a comment",
    ReceivedAReply: "replied to your comment",
    ReceivedALike: "liked your comment",
    CommentDeleted: "deleted your comment"
};
const ICON_SIZE = 24;
const COMMENT_ICON = /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
    className: "text-blue-900 group-hover:text-primary-900",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(messageSquare/* default */.Z, {
        size: ICON_SIZE,
        className: "-scale-x-1"
    })
});
const ICON_MAP = {
    ReceivedAComment: COMMENT_ICON,
    ReceivedAReply: COMMENT_ICON,
    ReceivedALike: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "text-pink-900 group-hover:text-primary-900",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(heartFill/* default */.Z, {
            size: ICON_SIZE
        })
    }),
    CommentDeleted: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: "text-gray-900 group-hover:text-primary-900",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(xSquare/* default */.Z, {
            size: ICON_SIZE
        })
    })
};

;// CONCATENATED MODULE: ../../packages/ui/src/blocks/notification-hub/notification-hub.tsx













function NotificationHub() {
    var ref;
    const { data: userData  } = (0,use_current_user/* useCurrentUser */.x)();
    const [{ data , fetching  }, refetchNotification] = useCurrentNotificationMessagesQuery({
        variables: {
            userId: userData.id || "-1"
        },
        pause: !userData.id
    });
    const refetchWithoutCache = (0,use_bypass_cache_refetch/* useBypassCacheRefetch */.X)(refetchNotification);
    const [{}, haveReadANotification] = useHaveReadANotificationMutation();
    const [{}, deleteNotificationMessage] = useDeleteNotificationMessageMutation();
    const hasUnreadNotifications = data === null || data === void 0 ? void 0 : data.notificationMessages.some((msg)=>!msg.read);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mr-4 flex flex-row items-center justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu */.v, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu.Button */.v.Button, {
                    className: (notification_hub_module_default()).menuButton,
                    // Refetch when opening the menu
                    onClick: (open)=>!open && refetchNotification(),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(bell/* default */.Z, {
                            size: 22
                        }),
                        hasUnreadNotifications && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* Badge */.C, {
                            className: "absolute top-1 right-1 !bg-red-900 ring-1 ring-white dark:ring-black"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu/* Menu.Items */.v.Items, {
                    className: (notification_hub_module_default()).menuItems,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
                            as: "h4",
                            className: "px-5 py-3 font-bold",
                            children: "Notifications"
                        }),
                        fetching && /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* Spinner */.$, {
                            className: "absolute right-0 pr-6 pt-2",
                            children: " "
                        }),
                        (data === null || data === void 0 ? void 0 : (ref = data.notificationMessages) === null || ref === void 0 ? void 0 : ref.length) || 0 > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-h-96 w-max overflow-y-auto",
                            children: data === null || data === void 0 ? void 0 : data.notificationMessages.map((msg, index)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(NotificationItem, {
                                    message: msg,
                                    index: index,
                                    length: data === null || data === void 0 ? void 0 : data.notificationMessages.length,
                                    onClickCapture: (messageId)=>haveReadANotification({
                                            messageId
                                        }),
                                    onClickDelete: async (messageId)=>{
                                        await deleteNotificationMessage({
                                            messageId
                                        });
                                        refetchWithoutCache();
                                    }
                                }, msg.id);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(text_text/* Text */.x, {
                            variant: "secondary",
                            className: "mx-5 mb-2 w-max rounded border border-dashed py-2 px-4 pb-2",
                            children: "No messages yet"
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 61551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ SideMenu; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../packages/utils/src/env.ts
var env = __webpack_require__(17849);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@1.2.1/node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(14517);
// EXTERNAL MODULE: ../../node_modules/.pnpm/framer-motion@7.6.2_biqbaboplfbrettd7655fr4n2y/node_modules/framer-motion/dist/es/utils/use-cycle.mjs + 1 modules
var use_cycle = __webpack_require__(45689);
// EXTERNAL MODULE: ../../node_modules/.pnpm/framer-motion@7.6.2_biqbaboplfbrettd7655fr4n2y/node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(85385);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../packages/ui/src/components/button/icon-button.tsx
var icon_button = __webpack_require__(6306);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/menu.js
var menu = __webpack_require__(16282);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@geist-ui+icons@1.0.2_react@18.2.0/node_modules/@geist-ui/icons/x.js
var x = __webpack_require__(12953);
;// CONCATENATED MODULE: ../../packages/ui/src/hooks/use-click-outside.ts

function useClickOutside(callback) {
    const containerRef = react.useRef(null);
    const callbackRef = react.useRef(callback);
    callbackRef.current = callback;
    react.useEffect(()=>{
        // eslint-disable-next-line unicorn/consistent-function-scoping
        const listener = (event)=>{
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                callbackRef.current();
            }
        };
        document.addEventListener("mousedown", listener);
        return ()=>document.removeEventListener("mousedown", listener);
    }, []);
    return containerRef;
}

;// CONCATENATED MODULE: ../../packages/ui/src/hooks/use-isomorphic-layout-effect.ts


const useIsomorphicLayoutEffect = env/* isSSRMode */.kp ? react.useEffect : react.useLayoutEffect;
/* harmony default export */ var use_isomorphic_layout_effect = (useIsomorphicLayoutEffect);

;// CONCATENATED MODULE: ../../packages/ui/src/hooks/use-froze-scroll.ts

/**
 * Froze body scroll when frozeScroll is true,
 * used in modal and drawer.
 * @param frozeScroll
 */ function useFrozeBodyScroll(frozeScroll) {
    use_isomorphic_layout_effect(()=>{
        if (frozeScroll) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.removeProperty("overflow");
        }
    }, [
        frozeScroll
    ]);
}

;// CONCATENATED MODULE: ../../packages/ui/src/blocks/side-menu/side-menu-context.tsx


const SideMenuContext = /*#__PURE__*/ react.createContext({
    onClickMenuItem: ()=>{
    //
    }
});
function SideMenuContextProvider(param) {
    let { onClickMenuItem , children  } = param;
    const onClickMenuItemRef = react.useRef(onClickMenuItem);
    onClickMenuItemRef.current = onClickMenuItem;
    const value = react.useMemo(()=>({
            onClickMenuItem: onClickMenuItemRef.current
        }), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenuContext.Provider, {
        value: value,
        children: children
    });
}
function useSideMenuContext() {
    const context = react.useContext(SideMenuContext);
    if (!context) {
        throw new Error("useSideMenuContext must be used within a SideMenuContextProvider");
    }
    return context;
}

;// CONCATENATED MODULE: ../../packages/ui/src/blocks/side-menu/side-menu.tsx










const circlePosStyle = {
    tl: "30px 32px",
    br: "calc(100% - 30px) calc(100% - 30px)"
};
const navVariants = {
    open: {
        zIndex: 21
    },
    closed: {
        transitionEnd: {
            zIndex: 0
        }
    }
};
/**
 * SideMenu is a toggle menu on mobile views.
 */ function SideMenu(param) {
    let { children , position ="tl" , styles , fixed  } = param;
    const [isOpen, toggleOpen] = (0,use_cycle/* useCycle */.n)(false, true);
    const containerRef = useClickOutside(()=>isOpen && toggleOpen(0));
    const [containerStyles, buttonStyles] = posStyles[position];
    const backgroundVariant = react.useMemo(()=>{
        const pos = circlePosStyle[position];
        return {
            open: function() {
                let height = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
                return {
                    clipPath: "circle(".concat(height * 2 + 200, "px at ").concat(pos, ")"),
                    transition: {
                        type: "spring",
                        stiffness: 20,
                        restDelta: 2
                    }
                };
            },
            closed: {
                clipPath: "circle(18px at ".concat(pos, ")"),
                transition: {
                    delay: 0.5,
                    type: "spring",
                    stiffness: 400,
                    damping: 40
                }
            }
        };
    }, [
        position
    ]);
    const [isAnimationEnd, setIsAnimationEnd] = react.useState(true);
    useFrozeBodyScroll(isOpen);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion_minimal.m.nav, {
        initial: false,
        variants: navVariants,
        animate: isOpen ? "open" : "closed",
        custom: !env/* isSSRMode */.kp ? document.body.clientHeight : undefined,
        className: (0,clsx_m/* default */.Z)("top-0 bottom-0 isolate h-[100vh] w-[250px]", containerStyles, isAnimationEnd && "h-auto", fixed ? "fixed" : "absolute sm:fixed"),
        ref: containerRef,
        onAnimationStart: (definition)=>definition === "open" && setIsAnimationEnd(false),
        onAnimationComplete: (definition)=>definition === "closed" && setIsAnimationEnd(true),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                className: (0,clsx_m/* default */.Z)("absolute inset-0 bg-gray-200", isAnimationEnd && "!hidden"),
                variants: backgroundVariant
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenuContextProvider, {
                onClickMenuItem: ()=>toggleOpen(0),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenuItems, {
                    className: styles === null || styles === void 0 ? void 0 : styles.items,
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(icon_button/* IconButton */.h, {
                "aria-expanded": isOpen,
                onClick: ()=>toggleOpen(),
                className: (0,clsx_m/* default */.Z)("bg-gray-100", buttonStyles),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sr-only",
                        children: "Open navigation menu"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)(isOpen && "hidden")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(x/* default */.Z, {
                        className: (0,clsx_m/* default */.Z)(!isOpen && "hidden")
                    })
                ]
            })
        ]
    });
}
SideMenu.Item = SideMenuItem;
const posStyles = {
    tl: [
        "left-0",
        "!absolute top-[18px] left-[18px]"
    ],
    br: [
        "right-0",
        "!fixed bottom-[18px] right-[18px]"
    ]
};
const itemsVariants = {
    open: {
        transition: {
            staggerChildren: 0.07,
            delayChildren: 0.2
        }
    },
    closed: {
        transition: {
            staggerChildren: 0.05,
            staggerDirection: -1
        }
    }
};
function SideMenuItems(param) {
    let { children , className  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.ul, {
        className: (0,clsx_m/* default */.Z)("absolute top-[75px] flex flex-col space-y-4", className),
        variants: itemsVariants,
        children: children
    });
}
const itemVariants = {
    open: {
        display: "block",
        y: 0,
        opacity: 1,
        transition: {
            y: {
                stiffness: 1000,
                velocity: -100
            }
        }
    },
    closed: {
        display: "block",
        y: 50,
        opacity: 0,
        transitionEnd: {
            display: "none"
        },
        transition: {
            y: {
                stiffness: 1000
            }
        }
    }
};
function SideMenuItem(param) {
    let { children  } = param;
    const { onClickMenuItem  } = useSideMenuContext();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.li, {
        variants: itemVariants,
        onClick: onClickMenuItem,
        children: children
    });
}


/***/ }),

/***/ 32075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71133);




function Spinner(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex flex-row space-x-1 text-gray-1100", props.className),
        "aria-label": "Loading data",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: "animate-spin"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: props.children || "Loading"
            })
        ]
    });
}


/***/ }),

/***/ 88905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useBypassCacheRefetch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32641);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93089);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63861);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utilities_gql_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31558);




/**
 * Bypass gql cache
 */ function useBypassCacheRefetch(refetch) {
    const { data  } = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_0__.useSession)();
    return (opts)=>{
        if (!refetch) {
            throw new Error("Refetch with empty func");
        }
        refetch((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, opts), {
            fetchOptions: {
                headers: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, (0,_utilities_gql_client__WEBPACK_IMPORTED_MODULE_3__/* .getAuthHeaders */ .g0)((data === null || data === void 0 ? void 0 : data.hasuraToken) || "")), {
                    "x-stellate-bypass": "true"
                })
            }
        }));
    };
}


/***/ }),

/***/ 3921:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"layout_layoutWrapper__OtbND","layoutMain":"layout_layoutMain__4ozn_"};

/***/ }),

/***/ 74394:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menuButton":"notification-hub_menuButton__NZACh"};

/***/ }),

/***/ 55076:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon":"select_icon__Ul5vj"};

/***/ })

}]);